import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdiomasServiceN35 {

  idEmpresa: string;
  idUsuario: string;
  idInfoUser: any;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idInfoUser=infoUsu;
    console.log('infoUsu',infoUsu);

    this.idEmpresa = infoUsu.empresaId;
  }

  getinfo(){
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    return infoUsu;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusIdioma(anio: number){
    let datos: any = {fechaCertificar: anio,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusIdioma(anio: number){
    let datos: any = {fechaCertificar: anio,	idiomas: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  getIdiomas(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.idiomasGuardados + this.idEmpresa);
  }

  guardaIdioma(idioma:backInter.nuevoIdioma){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.idiomasGuardados + this.idEmpresa, idioma);
  }

  borraIdioma(idIdioma:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.borrarIdioma + this.idEmpresa, idIdioma);
  }

  guardaDatosStep5(idioma:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.DataStep5Guardados + this.idEmpresa, idioma);
  }

  getStepsData(fecha:any){
    this.obtienInfo();
    let datos: any = {fechaDocumentador: fecha};
    if (this.idInfoUser.level!=6) {
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetDataStep5 + this.idEmpresa, datos);
    }else{
      console.log('Jalo este visen');

      return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetDataStep5 + localStorage.getItem('companyID'), datos);

    }
  }

  getStepsData_CT(fecha:any,idEmpresa){
    this.obtienInfo();
    let datos: any = {fechaDocumentador: fecha};
      if (this.idInfoUser.level!=6) {
        return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetDataStep5 + idEmpresa, datos);

      }else{
        return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetDataStep5 + localStorage.getItem('companyID'), datos);

      }
  }

  saveTask(idioma:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.DataSaveTask + this.idEmpresa, idioma);
  }

  getTask(fecha:any){
    let datos: any = {fechaDocumentador: fecha};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetTask + this.idEmpresa, datos);
  }

  deleteTask(idioma:any){
    //console.log("epa");
    //console.log(idioma);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.RemoveTask + this.idEmpresa, idioma);
  }

  getTaskOnly(idioma: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetTask+ this.idEmpresa,idioma);
  }

  getAllTask(){
    let datos: any = {fechaDocumentador: 2019 };
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetAllTask + this.idEmpresa,datos);
  }

  sendFilesValues(idioma:any){

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.SaveFiles + this.idEmpresa,idioma);
  }

  getFileValues(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetAllFile + this.idEmpresa,data);
  }

  DeleteFileValues(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.DeleteFile + this.idEmpresa,data);
  }

  SaveTareaPrimaria(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.SavePrimaryTask + this.idEmpresa,data);
  }

  getTareasPrimaria(data:any){
    console.log("Tareas primaria padre");
    console.log(data);
    console.log(this.idEmpresa);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetAllPrimaryTask + this.idEmpresa,data);
  }

  getTareasPrimaria_CT(data:any,idEmpresa){
    console.log("Tareas primaria padre");
    console.log(data);
    console.log(this.idEmpresa);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetAllPrimaryTask + idEmpresa,data);
  }

  saveFilesTaks(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.UploadPrimaryTaskFile + this.idEmpresa,data);
  }

  getArchPrimario(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetUploadPrimaryTaskFile + this.idEmpresa,data);
  }
  geTodoList(data:any){
    if (this.idInfoUser.level!=6) {
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetPrimaryTodoList + this.idEmpresa,data);
}else{
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetPrimaryTodoList + localStorage.getItem('companyID'),data);
}
  }
  geTodoListCT(data:any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetPrimaryTodoList + idEmpresa,data);
  }
  deletePrimaryFile(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.DeleteprimaryFile + this.idEmpresa,data);
  }
  updatePrimaryFile(data:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.UpdatePrimaryFile + this.idEmpresa,data);
  }


  borrarTareaPrimaria(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.deletetareaPrimaria + this.idEmpresa, datos);
  }
  getIDempresa(){
    return this.idEmpresa;
  }

}
